import createClient from 'openapi-fetch'

import type { PathsWithMethod } from 'openapi-typescript-helpers'
import { paths } from '~/api/OnPremAgentClient/generated-schema'
import CloudAPI from '../onPremAgent/cloudAPI'
import CronjobAPI from '../onPremAgent/cronjobAPI'
import DataIngestorsAPI from '../onPremAgent/dataIngestorsAPI'
import DatasetsAPI from '../onPremAgent/datasetsAPI'
import { OpenApiFetchOptions, OpenApiFetchResponse } from '../shared/openApiTypes'
import { unwrapBackendResponse } from '../shared/unwrapBackendResponse'

class OnPremAgentClient {
  // Pages
  dataIngestors: DataIngestorsAPI
  datasets: DatasetsAPI
  cloud: CloudAPI
  cron: CronjobAPI

  constructor() {
    this.dataIngestors = new DataIngestorsAPI(this)
    this.datasets = new DatasetsAPI(this)
    this.cloud = new CloudAPI(this)
    this.cron = new CronjobAPI(this)
  }

  _createClient = async () => {
    return createClient<paths>({
      baseUrl: process.env.MONOMER_ON_PREM_AGENT_ORIGIN,
    })
  }

  async GET<P extends PathsWithMethod<paths, 'get'>>(
    url: P,
    ...init: OpenApiFetchOptions<paths, 'get', P>
  ): Promise<NonNullable<OpenApiFetchResponse<paths, 'get', P>['data']>> {
    const client = await this._createClient()
    const response = client.GET(url, ...init)
    return unwrapBackendResponse(response)
  }

  async POST<P extends PathsWithMethod<paths, 'post'>>(
    url: P,
    ...init: OpenApiFetchOptions<paths, 'post', P>
  ): Promise<NonNullable<OpenApiFetchResponse<paths, 'post', P>['data']>> {
    const client = await this._createClient()
    const response = client.POST(url, ...init)
    return unwrapBackendResponse(response)
  }

  async PUT<P extends PathsWithMethod<paths, 'put'>>(
    url: P,
    ...init: OpenApiFetchOptions<paths, 'put', P>
  ): Promise<NonNullable<OpenApiFetchResponse<paths, 'put', P>['data']>> {
    const client = await this._createClient()
    const response = client.PUT(url, ...init)
    return unwrapBackendResponse(response)
  }

  async DELETE<P extends PathsWithMethod<paths, 'delete'>>(
    url: P,
    ...init: OpenApiFetchOptions<paths, 'delete', P>
  ): Promise<NonNullable<OpenApiFetchResponse<paths, 'delete', P>['data']>> {
    const client = await this._createClient()
    const response = client.DELETE(url, ...init)
    return unwrapBackendResponse(response)
  }
}

export default OnPremAgentClient
